import { API } from 'aws-amplify';
import { personAdminFunctions } from '../../graphql/mutations';

// sam-personAdminFunctions sets User.status ('enable' → active, 'disable' →
// disabled) and enables/disables the Cognito login by username, so username
// is required. It returns "FAIL" instead of throwing.
export async function setUserStatus(
  user: { id: string; username: string },
  action: 'enable' | 'disable'
) {
  const res: any = await API.graphql({
    query: personAdminFunctions,
    variables: { userID: user.id, username: user.username, action },
  });
  if (res?.data?.personAdminFunctions !== 'SUCCESS') {
    throw new Error(`personAdminFunctions ${action} failed`);
  }
}
